import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizier:DomSanitizer){
    
  }
  transform(url): any {
    return this.sanitizier.bypassSecurityTrustResourceUrl(url);
  }

}
